import moment from 'moment';

const PolicyListColumn = [
  {
    title: 'No.',
    dataIndex: 'index',
    sorter: (a, b) => a.index - b.index,
    width: 100
  },
  {
    title: 'Policy Name',
    dataIndex: 'name',
    sorter: (a, b) => a.name.localeCompare(b.name),
    width: 250
  },
  {
    title: 'Policy Description',
    dataIndex: 'description',
    sorter: (a, b) => a.description.localeCompare(b.description),
    width: 250
  },
  {
    title: 'Selected URLs',
    dataIndex: 'urls',
    slot: 'urls',
    width: 250
  },
  {
    title: 'Date Created',
    dataIndex: 'create_date',
    slot: 'create_date',
    sorter: (a, b) => moment(a.create_date).diff(moment(b.create_date)),
    width: 200
  },
  {
    title: '',
    dataIndex: '',
    slot: 'operation',
    width: 50
  }
];
export { PolicyListColumn };
